import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/auth.context';
import { ApiError } from '../api/client';

export function LoginPage(): JSX.Element {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const message =
        err instanceof ApiError ? err.message : 'erro ao fazer login. tente novamente.';
      setError(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center px-4 bg-sara-bg">
      <form
        onSubmit={handleSubmit}
        className="card w-full max-w-sm space-y-5 animate-fade-in"
        aria-label="Formulário de login"
      >
        <header className="space-y-2">
          <span
            aria-hidden="true"
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-sara-accent text-sara-accent-fg text-base font-bold shadow-sara-pop"
          >
            S
          </span>
          <h1 className="h1">Painel Sara</h1>
          <p className="text-sm text-sara-text-muted">Acesso restrito ao time interno.</p>
        </header>

        <div>
          <label htmlFor="email" className="label">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            autoComplete="email"
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            aria-describedby={error ? 'login-error' : undefined}
          />
        </div>

        <div>
          <label htmlFor="password" className="label">
            Senha
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            minLength={8}
            autoComplete="current-password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            aria-describedby={error ? 'login-error' : undefined}
          />
        </div>

        {error && (
          <p id="login-error" role="alert" className="text-sm text-sara-danger">
            {error}
          </p>
        )}

        <button type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? 'entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
